import { useQuery } from '@tanstack/react-query'
import { TUser } from 'shared/types'
import { api } from '..'

export const getMe = () =>
  api.get<TUser>('/v1/users/user').then(({ data }) => data)

export const meQuery = {
  queryFn: getMe,
  queryKey: ['users', 'me'],
}

export const useGetMe = (onSuccess?: (data: TUser) => void) => {
  return useQuery({
    ...meQuery,
    onSuccess,
  })
}
